<template>
  <div>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-3">
            <v-layout justify-center class="mt-2 pt-3">
              <p  class="primary--text">{{reservationForm.name}}</p>
            </v-layout>
            <v-layout  column class="ml-2 mr-2">
              <v-flex>
                <v-textarea
                  v-model="reservationForm.description"
                  prepend-icon="mdi-text"
                  rows="1"
                  auto-grow
                  label="自助预约活动描述"
                  readonly
                >
                </v-textarea>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="reservationForm.passRule.startDatetime"
                  prepend-icon="mdi-clock"
                  label="最早授权进场时间"
                  readonly
                >
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  v-model="reservationForm.passRule.endDatetime"
                  prepend-icon="mdi-clock"
                  label="最迟要求离场时间"
                  readonly
                >
                </v-text-field>
              </v-flex>
              <v-flex class="pl-2">
                <v-btn flat color="primary" @click="showControllers=!showControllers" v-show="!showControllers">查看允许通行场区及关口</v-btn>
                <v-btn flat color="primary" @click="showControllers=!showControllers" v-show="showControllers">隐藏允许通行场区及关口</v-btn>
                <v-layout class="pl-4" v-show="showControllers">
                  <v-flex xs12 v-for="n in reservationForm.passRule.gateways" :key="n.id">
                    <p>允许通行场区：{{n.name}}</p>
                    <layout column>
                      <p>允许通行关口：</p>
                      <v-flex v-for="i in n.controllers" :key="i.id">
                        <p>{{i.name}}</p>
                      </v-flex>
                    </layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <h3 class="error--text">{{unUseReasonTitle}}</h3>
                <p class="error--text" style="font-size: 16px" v-html="unUseReason"></p>
              </v-flex>
            </v-layout>
            <!-- <div class="mt-3">
                 <span class="primary&#45;&#45;text ml-4 mt-5">函件预约规则管理</span>
             </div>-->
            <v-divider></v-divider>
            <v-form ref="registerForm" class="pa-2" v-if="useFlag===true">
              <v-layout column>
                <v-flex>
                  <l-plate-picker
                    v-model="registerForm.veCode"
                    label="车辆号牌*"
                    :disabled="disabledFlag===true"></l-plate-picker>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="registerForm.phone"
                    label="手机号码*"
                    :disabled="disabledFlag===true"
                    prepend-icon="mdi-phone"
                    :rules="$rules.phone11()"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-show="reservationForm.veSelfRegRule.name===true">
                <v-flex>
                  <v-text-field
                    prepend-icon="mdi-account"
                    v-model="registerForm.name"
                    :label="(reservationForm.veSelfRegRule.name===true)?'车主姓名*':'车主姓名'"
                    :disabled="disabledFlag===true"
                    :rules="(reservationForm.veSelfRegRule.name===true)?[$rules.requiredS()]:[]"
                    ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-show="reservationForm.veSelfRegRule.org===true">
                <v-flex>
                  <v-text-field
                    :label="(reservationForm.veSelfRegRule.org===true)?'车主单位*':'车主单位'"
                    prepend-icon="mdi-account-group"
                    v-model="registerForm.org"
                    :disabled="disabledFlag===true"
                    :rules="(reservationForm.veSelfRegRule.org===true)?[$rules.requiredS()]:[]"
                   ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout column>
                <v-flex xs6 v-show="reservationForm.veSelfRegRule.idType===true">
                  <v-select
                    :label="(reservationForm.veSelfRegRule.idType===true)?'证件类型*':'证件类型'"
                    v-model="registerForm.type"
                    :items="registerForm.typeSelect"
                    :disabled="disabledFlag===true"
                    :rules="(reservationForm.veSelfRegRule.idType===true)?[$rules.requiredS()]:[]"
                    item-text="text"
                    item-value="text"
                    prepend-icon="mdi-account-box"
                  ></v-select>
                </v-flex>
                <v-flex xs6 v-show="reservationForm.veSelfRegRule.id===true">
                  <v-text-field
                    :label="(reservationForm.veSelfRegRule.id===true)?'证件号码*':'证件号码'"
                    v-model="registerForm.idCard"
                    :disabled="disabledFlag===true"
                    :rules="(reservationForm.veSelfRegRule.id===true)?[$rules.requiredS()]:[]"
                    prepend-icon="mdi-account-card-details"
                    ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs9>
                  <v-text-field
                    class="pb-1"
                    single-line
                    prepend-icon="$vuetify.icons.code"
                    label="验证码"
                    placeholder="请输入验证码"
                    v-model="verifyObj.verifyCode"
                    :disabled="disabledFlag===true"
                    :error-messages="(disabledFlag===true)?'':verifyObj.errorMessage"
                  ></v-text-field>
                </v-flex>
                <v-btn flat color="primary" @click="getTmpToken();verifyObj.getFlag=true" :disabled="disabledFlag===true" v-if="verifyObj.expire<=0">
                  <span>点击获取短信验证码</span>
                </v-btn>
                <span v-else style="font-size: 16px">{{verifyObj.expire}}s</span>
              </v-layout>
            </v-form>
            <v-layout justify-center v-if="useFlag">
              <v-btn class="primary" :loading="loading" @click="checkCode();hintVerify()" :disabled="disabledFlag===true||submitDisabled===true">提交</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>
<script>
import LPlatePicker from '../../../components/LPlatePicker'
export default{
  components: {
    LPlatePicker,
  },
  data () {
    return {
      reservationForm: {
        name: '',
        description: '',
        passRule: '',
        veSelfRegRule: {
          id: false,
          idType: false,
          name: false,
          org: false,
          phone: true,
          veNum: true
        }
      },
      interviewee: '',
      showControllers: false,
      registerForm: {
        name: '',
        type: '',
        idCard: '',
        veCode: '',
        phone: '',
        org: '',
        typeSelect: [
          {
            text: '居民身份证',
            value: 'idCard'
          },
          {
            text: '军官证|警官证|士兵证',
            value: 'osCard'
          },
          {
            text: '护照',
            value: 'passport'
          },
          {
            text: '港澳|台湾居民来往内地通行证',
            value: 'mtPermit'
          }
        ]
      },
      verifyObj: {
        show: false,
        getFlag: false,
        expire: 0,
        key: '',
        verifyCode: '',
        verifyKey: '',
        errorMsg: ''
      },
      loading: false,
      disabledFlag: false,
      procInstId: '',
      useFlag: true,
      unUseReason: '',
      unUseReasonTitle: '',
      submitDisabled: true
    }
  },
  methods: {
    async getReservationInfo () {
      let res = await this.$store.dispatch('letterReservation/selfSign_getReservationInfo', this.$route.query.procInstId)
      if (res.data.code + '' === '200') {
        // console.log(data)
        this.dealActivityInfo(res.data.data)
      }
      else {
        this.$L.alert('error', {message: '查询预约信息失败'})
      }
    },
    dealActivityInfo (data) {
      console.log(data)
      this.reservationForm.name = data.obGrpName
      this.reservationForm.description = data.obGrpDesc
      this.reservationForm.passRule = data.passRuleConf[0]
      this.useFlag = data.qrCodeStatus
      if (!this.useFlag) {
        let arr = data.unUseReason.split('：')
        // console.log(arr);
        this.unUseReasonTitle = arr[0]
        for (let i = 1; i < arr.length; i++) {
          if (i === arr.length - 1) {
            for (let j = 0; j < arr[i].length; j++) {
              if (arr[i][j] === '$') {
                this.unUseReason += '<br/>'
              }
              else {
                this.unUseReason += arr[i][j]
              }
            }
          }
          else {
            for (let j = 0; j < arr[i].length; j++) {
              if (arr[i][j] === '$') {
                this.unUseReason += '<br/>'
              }
              else {
                this.unUseReason += arr[i][j]
              }
            }
            this.unUseReason += '：'
          }
        }
      }
    },
    async submitForm () {
      if (this.$refs.registerForm.validate()) {
        let obj = {
          updatedVel: this.registerForm.veCode.toUpperCase(),
          updatedPhone: this.registerForm.phone,
          updatedCampus: this.registerForm.org,
          updatedName: this.registerForm.name,
          updateIdType: this.registerForm.type,
          updateIdNum: this.registerForm.idCard
        }
        let config = {
          formKey: 'spava_pass-control_form_act-cfg',
          procInstId: this.procInstId,
          updateVelInFormList: [
            obj
          ]
        }
        let res = await this.$store.dispatch('letterReservation/selfSign_submit', {verifyKey: this.verifyObj.verifyKey, openId: this.openId, config: config})
        if (res.data.code + '' === '200') {
          this.verifyObj.errorMsg = ''
          this.verifyObj.expire = 0
          this.$L.alert('error', {title: '提示', message: res.data.msg})
        }
        else {
          this.$L.alert('error', {message: res.data.msg})
          this.disabledFlag = false
          this.verifyObj.expire = -1
          // console.log("1231");
          this.verifyObj.errorMsg = res.data.msg + ',请重新获取'
          // console.log(this.verifyObj.errorMsg);
        }
        this.loading = false
      }
      else {
        this.loading = false
        this.disabledFlag = false
        this.$L.alert('error,', {message: '表单数据不合法'})
      }
    },
    async getTmpToken () {
      if (!this.$refs.registerForm.validate()) {
        alert('表单存在不合法数据，请先完善表单')
        return
      }
      this.verifyObjReset()
      this.disabledFlag = true
      let res = await this.$store.dispatch('letterReservation/selfSign_getTmpToken')
      this.disabledFlag = false
      if (res.data.status === 1) {
        this.verifyObj.key = res.data.data.key
        this.verifyObj.expire = 60
        this.sendVertifyMessage()
      }
      else {
        this.verifyObjReset()
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async sendVertifyMessage () {
      this.disabledFlag = true
      let res = await this.$store.dispatch('letterReservation/selfSign_getVerifyMsg', {key: this.verifyObj.key, phone: this.registerForm.phone})
      this.disabledFlag = false
      if (res.data.status === 1) {
        this.verifyObj.verifyKey = res.data.data.verifyKey
      }
      else {
        this.verifyObjReset()
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async checkCode () {
      this.loading = true
      this.disabledFlag = true
      let config = {
        'verifyKey': this.verifyObj.verifyKey,
        'realMsg': this.verifyObj.verifyCode
      }
      let res = await this.$store.dispatch('letterReservation/selfSign_checkVerify', config)

      if (res.data.status === 1) {
        // this.verifyObjReset();
        this.submitForm()
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
        this.loading = false
        this.disabledFlag = false
        this.verifyObj.expire = -1
        this.verifyObj.errorMsg = res.data.msg + ',请重新获取'
      }
    },
    verifyObjReset () {
      this.verifyObj.show = false
      this.verifyObj.getFlag = false
      this.verifyObj.verifyCode = ''
      this.verifyObj.errorMsg = ''
      this.verifyObj.expire = 0
    },
    hintVerify () {
      this.verifyObj.show = true
      this.verifyObj.errorMsg = '请点击获取手机验证码'
    },
    intervieweeSearch () {}
  },
  created () {
    this.procInstId = this.$route.query.procInstId
    this.openId = this.$route.query.openId
    // console.log(this.openId);
    this.getReservationInfo()
  },
  mounted () {
    this.$refs.registerForm.validate()
  },
  /*  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('changeAppTitle', {full: '车辆进校自助登记', abbr: '车辆进校自助登记'})
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('resetAppTitle')
    next()
  }, */
  watch: {
    'verifyObj.expire' (val, oldVal) {
      if (val > 0) {
        if (val > oldVal) {
          setTimeout(() => {
            this.verifyObj.expire = val - 1
          }, 1000)
        }
        else {
          setTimeout(() => {
            this.verifyObj.expire -= 1
          }, 1000)
        }
      }
      else if (val === 0) {
        this.verifyObj.errorMessage = '验证码已过期，请重新获取'
      }
      else {}
    },
    /*  'registerForm.veCode'(val,oldVal){
        //console.log("123123");
          this.registerForm.veCode = this.registerForm.veCode.toUpperCase();
      }, */
    'verifyObj.verifyCode' () {
      // console.log('change')
      this.verifyObj.errorMessage = ''
      if (this.verifyObj.verifyCode.length === 4) {
        this.submitDisabled = false
      }
    }
  }
}
</script>
<style>

</style>
